import React, {useEffect} from "react";
import Price from "components/Price";
import IconCencosudCard from 'components/IconCencosudCard';
import PropTypes from "prop-types";

const maxAmount = 3000000;
const alertAmmount = maxAmount - 50000;

const Totals = (props) => {
    const { totalizers, alertAmount } = props;

    if(!totalizers) return '';

    const getValue = (id) => {
        const items = totalizers.filter(item => item.id === id);
        return items[0] ? Math.abs(items[0].value) : 0;
    };

    const discountTcenco = getValue('DiscountsTcenco');
    const discount = getValue('Discounts');
    const subTotal = getValue('Items') - discount;
    const tcenco = getValue('Tcenco');


    useEffect(() => {
        const totalAmount = (subTotal / 100);

        if(totalAmount >= alertAmmount && totalAmount < maxAmount){
            alertAmount(maxAmount, false);
        } else if(totalAmount >= maxAmount){
            alertAmount(maxAmount, true);
        }

    }, [totalizers]);

    return <div className="minicart-totals">
        {(discount) ? <div className="discount-minicart">
            <span className="text">Descuentos</span>
            <span className="pull-right discount">
                - <Price price={(discount / 100)} />
            </span>
        </div> : ''}
        {(discountTcenco > discount) ? <div className="discount-minicart-cenco">
            <span className="text">
                Descuentos
                <br />
                <span className='discount-minicart-cenco-detail'>Pagando con T. Cencosud</span>
            </span>
            <span className="pull-right discount">
                - <Price price={(discountTcenco / 100)} />
            </span>
        </div> : ''}
        <div className="minicart-subtotal">
            <span className="text">Subtotal</span>
            <span className="subtotal-price">
                <Price price={subTotal / 100} />
            </span>
        </div>
        {tcenco < subTotal && <div className="minicart-subtotal-cenco">
            <span className="text">
                T. Cencosud Scotiabank
            </span>
            <span className="subtotal-price">
                <IconCencosudCard className="tarjeta-cenco" />
                <Price price={tcenco / 100} />
            </span>
        </div>}
    </div>;
};

Totals.propTypes = {
    totalizers: PropTypes.array,
    alertAmount: PropTypes.func
};

export default Totals;
